<template>
  <form>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>I am available for</h1>

        <a @click="$router.go(-1)" class="btn btn-info" active-class="">
          <i class="fa fa-chevron-left"></i> Back
        </a>
      </div>
    </div>

    <div class="container-fluid">

      <div class="dashboard-block">

        <div class="row">
          <div class="col-md-10 col-lg-8">

            <div class="panel panel-grey">
              <div class="panel-body">
                <h4 class="heading">Packages</h4>
                <ul class="package-list">
                  <profile-talent-packages-list-item v-for="(pkg, index) in packages" :key="pkg.id" :pkg="pkg"
                                                     :validation="$v.packages.$each[index]"
                                                     :user="user"/>
                </ul>
              </div>
            </div>

            <div class="margin-20"></div>

            <ladda-button
              type="submit"
              class="btn btn-primary"
              :click="handleSavePackagesCallback"
              :disabled="$v.$invalid"
            >
              Save Changes
            </ladda-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {notify} from 'utils'
import Selectize from '../ext/codium/CodiumSelectize'
import ProfileTalentPackagesListItem from './ProfileTalentPackagesListItem'
import {requiredIf, minValue} from 'vuelidate/lib/validators'
import { OpportunityTracker } from 'mixins/analytics'

const mustSelectPackageOption = (value) => {
  if (!value.opted_in) return true
  if (value.package_options.length < 2) return true
  return value.package_options.filter(option => option.opted_in === true).length > 0
}

export default {
  mixins: [OpportunityTracker],
  components: {
    ProfileTalentPackagesListItem,
    Selectize
  },

  data () {
    return {
      packages: []
    }
  },

  validations: {
    packages: {
      $each: {
        mustSelectPackageOption,
        package_options: {
          $each: {
            budget: {
              required: requiredIf(info => {
                return info.opted_in
              }),
              minValue: minValue(1)
            }
          }
        }
      }
    }
  },

  computed: {
    ...mapState('user', ['user'])
  },

  mounted () {
    this.getTalentPackages(this.$route.params.id).then(response => {
      this.packages = response.data
    })
  },

  methods: {
    ...mapActions('talent/profile', ['getTalentPackages', 'updateTalentPackages']),

    handleSavePackagesCallback () {
      return this.updateTalentPackages({
        id: this.user.id,
        payload: { packages: this.packages }
      }).then(() => {
        notify.success('Successfully saved your packages.')
        this.trackEvent(this.analytics.V2.AccountSectionEditEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.PACKAGES })
      }).catch((errors) => {
        notify.error('Sorry something went wrong saving your changes, please try again.')
        throw errors
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.heading {
  margin-bottom: 20px;
}
.package-list {
  list-style: none;
  padding-left: 0px;
  li {
    margin-bottom: 30px;
  }
}
</style>
